import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyPasswordResetCode } from 'firebase/auth';
import { ref, get } from 'firebase/database';
import { auth, db } from '../firebase';
import { useAuth } from '../hooks/useAuth';

const InvitePage = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [verifying, setVerifying] = useState(true);
  const [email, setEmail] = useState('');
  const [uid, setUid] = useState('');
  const [profileData, setProfileData] = useState(null);
  const { confirmInvite, loading, error } = useAuth();
  const navigate = useNavigate();

  const oobCode = searchParams.get('oobCode');

  useEffect(() => {
    if (!oobCode) {
      navigate('/login');
      return;
    }
    // oobCodeを検証してメールアドレスを取得
    verifyPasswordResetCode(auth, oobCode)
      .then(async (email) => {
        setEmail(email);
        // DBからUID・プロフィール情報を検索
        const usersRef = ref(db, 'users');
        const snapshot = await get(usersRef);
        const users = snapshot.val() || {};
        const entry = Object.entries(users).find(
          ([, u]) => u.email === email
        );
        if (entry) {
          setUid(entry[0]);
          setProfileData(entry[1]);
        }
        setVerifying(false);
      })
      .catch(() => {
        navigate('/login');
      });
  }, [oobCode, navigate]);

  const handleSubmit = async () => {
    if (password !== confirm) return;
    if (password.length < 8) return;
    const success = await confirmInvite(oobCode, password, uid, profileData, email);
    if (success) navigate('/login?invited=1');
  };

  if (verifying) {
    return (
      <div style={styles.root}>
        <p>招待URLを確認中...</p>
      </div>
    );
  }

  return (
    <div style={styles.root}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <span style={styles.logoIcon}>🎭</span>
          <h1 style={styles.logoText}>VRChat Matching</h1>
          <p style={styles.subtitle}>パスワードを設定してアカウントを有効化してください</p>
        </div>

        <div style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>メールアドレス</label>
            <input
              style={{ ...styles.input, background: '#f4f6fb', color: '#999' }}
              type="email"
              value={email}
              disabled
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>パスワード（8文字以上）</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="パスワードを入力"
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>パスワード（確認）</label>
            <input
              style={styles.input}
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="もう一度入力"
              onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            />
          </div>

          {password !== confirm && confirm && (
            <p style={styles.error}>パスワードが一致しません</p>
          )}
          {error && <p style={styles.error}>{error}</p>}

          <button
            style={{ ...styles.button, opacity: loading ? 0.7 : 1 }}
            onClick={handleSubmit}
            disabled={loading || password !== confirm || password.length < 8}
          >
            {loading ? '設定中...' : 'パスワードを設定してログイン'}
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#f4f6fb'
  },
  card: {
    background: '#fff',
    borderRadius: '16px',
    padding: '40px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
  },
  logo: {
    textAlign: 'center',
    marginBottom: '32px'
  },
  logoIcon: { fontSize: '40px' },
  logoText: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '8px 0 4px'
  },
  subtitle: {
    fontSize: '13px',
    color: '#888',
    margin: 0
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  label: {
    fontSize: '13px',
    fontWeight: '500',
    color: '#555'
  },
  input: {
    padding: '12px 14px',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    fontSize: '14px',
    outline: 'none'
  },
  button: {
    padding: '12px',
    borderRadius: '8px',
    border: 'none',
    background: '#6c63ff',
    color: '#fff',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '8px'
  },
  error: {
    color: '#ef4444',
    fontSize: '13px',
    margin: 0
  }
};

export default InvitePage;
